import React, { useState } from 'react';
import experienceVideoCover from '../../../assets/images/solutions/experience_video_cover.jpg';

const ExperienceSection = () => {
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlayClick = () => {
        setIsPlaying(true);
    };

    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Left Side - Description */}
                    <div className="space-y-6">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                            Experience the Future of Learning
                        </h2>
                        <p className="text-lg text-gray-600 leading-relaxed">
                            Watch how NexGen Learning transforms education for teachers, companies, and course creators.
                            Our AI-driven platform adapts to every learner's needs—boosting engagement and improving
                            results for classrooms, employees, and learners everywhere.
                        </p>
                        <div className="flex flex-wrap gap-4">
                            <div className="flex items-center space-x-2">
                                <div className="w-2 h-2 bg-primary rounded-full"></div>
                                <span className="text-gray-700">Personalized Learning</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <div className="w-2 h-2 bg-primary rounded-full"></div>
                                <span className="text-gray-700">AI-Powered Platform</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <div className="w-2 h-2 bg-primary rounded-full"></div>
                                <span className="text-gray-700">Enhanced Engagement</span>
                            </div>
                        </div>
                    </div>

                    {/* Right Side - Video */}
                    <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl">
                        <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-purple-500/20 z-10"></div>

                        {!isPlaying ? (
                            <div className="relative w-full h-full cursor-pointer group">
                                <img
                                    src={experienceVideoCover}
                                    alt="Experience Video Cover"
                                    className="w-full h-full object-cover"
                                />
                                {/* Play Button Overlay */}
                                <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-all duration-300">
                                    <div className="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center group-hover:bg-white transition-all duration-300 cursor-pointer z-20" onClick={handlePlayClick}>
                                        <div className="w-0 h-0 border-t-[15px] border-t-transparent border-l-[25px] border-l-primary border-b-[15px] border-b-transparent ml-1 group-hover:scale-110 transition-transform duration-300"></div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <iframe
                                className="w-full h-full"
                                src="https://player.vimeo.com/video/1060229574?color&autoplay=1&rel=0&controls=1&h=6e5ea95130#t="
                                title="Nexgen Learning Experience"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ExperienceSection; 